import { useLayoutEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { useGetSpaces } from '@/entities/teamspace';

import { Loader } from '@/shared/ui/Loader';

export const LegacyRouteBackwardCompatibility = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const spaces = useGetSpaces();

  useLayoutEffect(() => {
    if (!spaces.data) return;

    const space = spaces.data?.[0];

    if (!space?.id) return;

    navigate(`/spaces/${space.id}${location.pathname}`, { replace: true });
  }, [location, navigate, spaces.data, spaces.isLoading]);

  return <Loader />;
};
